import _ from 'lodash';
import customerEnum from './customerEnum';

const tranformObjToArr = obj => _.map(obj, n => ({ value: n, label: n }));

export default {
  attributeType: tranformObjToArr(customerEnum.attributeType),
  mandatory: tranformObjToArr(customerEnum.mandatory),
};
